import { Component } from 'react'
import { connect } from 'react-redux'
import { PROPOSALS_CLIENT_FETCH_REQ } from '../actions'
import { ProposalsReviewTemplate } from 'components/Dashboard/ProposalsReviewTemplate'
import { fromProposals } from '../serializers'

@connect(({ dashboard }) => {
  return {
    dashboard
  }
})
class ProposalsClientContainer extends Component {
  componentDidMount() {
    this.props.dispatch({
      type: PROPOSALS_CLIENT_FETCH_REQ
    })
  }

  render() {
    return (
      <ProposalsReviewTemplate
        title="Proposals Ready to Send to Client"
        subTitle="Below is a list of opportunities I have proposals ready to send to client"
        proposals={fromProposals(this.props.dashboard.proposalsReadyToSentToClient)}
      />
    )
  }
}

export default ProposalsClientContainer
